export const mapboxToken =
  process.env.MAPBOX_TOKEN_ASK_VA || process.env.MAPBOX_TOKEN;
